import { renderMermaidFallback } from '@hq/chat-ui';

// Shared markstream-vue render config, used by every <MarkdownRender> in the SPA.
// KEEP IN SYNC with apps/extension/entrypoints/sidepanel/App.vue.
//
//  - Code fences highlight with Shiki (the stream-markdown peer + the `^shiki$`
//    Vite alias -> src/lib/shikiCurated.ts curated bundle). The renderer lazy-loads
//    each grammar on first use, so MD_CODE_LANGS only PRELOADS the common ones to
//    avoid a first-paint flash; anything else still highlights on demand (and any
//    language outside the curated bundle falls back to plain text). The node's default
//    vitesse-light/dark themes are warm + low-contrast and sit well against the palette.
//  - MD_CODE_PROPS keeps the header (language label + copy button) but drops the
//    expand control - it fits the chat column without a fullscreen toggle.
//  - Mermaid height is capped so a tall diagram scrolls inside its block instead of
//    pushing the rest of the message far down.
export const MD_CODE_LANGS = [
  'typescript', 'javascript', 'tsx', 'vue', 'python', 'rust', 'go',
  'json', 'yaml', 'toml', 'bash', 'shell', 'sql', 'html', 'css',
  'markdown', 'diff',
] as const;

export const MD_CODE_PROPS = {
  showHeader: true,
  showCopyButton: true,
  showExpandButton: false,
} as const;

// onRenderError: on an unparseable diagram, show the source as a code block
// (shared @hq/chat-ui helper) instead of markstream's bare error line. NB: mermaid is
// now rendered by HqMermaid (setCustomComponents override in main.ts), which has its
// own source fallback - this only fires for any diagram markstream still handles itself.
export const MD_MERMAID_PROPS = { maxHeight: '520px', onRenderError: renderMermaidFallback } as const;
